module.exports = __webpack_public_path__ + "VIPV9.png?c8d96840a47cd2ff9e6bf93b1d88ba56";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV9.png
// module id = 142
// module chunks = 0